import { Base } from "../../framework/base";
import { stateGreen, stateOrange, stateRed } from "../consts";
import { UserFurtherEducationState } from "../enums";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "../recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { IRecordListItemUserFurtherEducation, RecordListItemUserFurtherEducation } from "../recordUserFurtherEducation/recordListItemUserFurtherEducation";
import { Translations } from "../translations";
import { IRecordQualificationUserFurtherEducation, RecordQualificationUserFurtherEducation } from "./recordQualificationUserFurtherEducation";

export interface IRecordQualificationSimple {
    id: string;
    furtherEducationId: string;
    furtherEducationGroupId: string;
    //Calculated fields
    code: string;
    requiredQualificationCount: number;
    furtherEducations: IRecordQualificationUserFurtherEducation[];
    userFurtherEducations: IRecordQualificationUserFurtherEducation[];
    validUserFurtherEducations: IRecordQualificationUserFurtherEducation[];
    valid: boolean;
    validityEndDate: number;
}

export interface IRecordUserFurtherEducationSimple {
    id: string;
    furtherEducationId: string;
    validityEndDate: number;
    getIsArchived(): boolean;
}

export interface IRecordUserQualificationValidityData {
    furtherEducationId: string;
    furtherEducationValid: boolean;
    furtherEducationValidityEndDate: number;
    recordUserFurtherEducationId: string;
}

export interface IRecordListItemUserQualification extends IRecordQualificationSimple {
    //Additional properties used in mobile UI
    state: UserFurtherEducationState;
    fullQualificationUserFurtherEducations: IRecordListItemUserFurtherEducation[];
    fullUserFurtherEducations: IRecordListItemUserFurtherEducation[];
}

export class RecordListItemUserQualification implements IRecordListItemUserQualification {
    id: string;
    furtherEducationId: string;
    furtherEducationGroupId: string;
    //Calculated fields
    code: string;
    requiredQualificationCount: number;
    furtherEducations: IRecordQualificationUserFurtherEducation[];
    userFurtherEducations: IRecordQualificationUserFurtherEducation[];
    validUserFurtherEducations: IRecordQualificationUserFurtherEducation[];
    valid: boolean;
    validityEndDate: number;
    //Additional properties used in mobile UI
    state: UserFurtherEducationState;
    fullQualificationUserFurtherEducations: IRecordListItemUserFurtherEducation[];
    fullUserFurtherEducations: IRecordListItemUserFurtherEducation[];

    constructor();
    constructor(obj: IRecordListItemUserQualification);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.furtherEducationGroupId = obj && obj.furtherEducationGroupId || "";
        //Calculated fields
        this.code = obj && obj.code || "";
        this.requiredQualificationCount = obj && obj.requiredQualificationCount || 0;
        this.furtherEducations = Base.getTypedArray(obj ? obj.furtherEducations : null, RecordQualificationUserFurtherEducation);
        this.userFurtherEducations = Base.getTypedArray(obj ? obj.userFurtherEducations : null, RecordQualificationUserFurtherEducation);
        this.validUserFurtherEducations = Base.getTypedArray(obj ? obj.validUserFurtherEducations : null, RecordQualificationUserFurtherEducation);
        this.valid = obj && obj.valid || false;
        this.validityEndDate = obj && obj.validityEndDate || null;
        //Additional properties used in mobile UI
        this.state = obj && obj.state || UserFurtherEducationState.Valid;
        this.fullQualificationUserFurtherEducations = Base.getTypedArray(obj ? obj.fullQualificationUserFurtherEducations : null, RecordListItemUserFurtherEducation);
        this.fullUserFurtherEducations = Base.getTypedArray(obj ? obj.fullUserFurtherEducations : null, RecordListItemUserFurtherEducation);
    }

    // setQualificationFullUserFurtherEducations(furtherEducationGroups: IRecordFurtherEducationGroupNode[]) {
    //     this.qualificationFullUserFurtherEducations = [];
            
    //         const furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(furtherEducationGroups, qualification.furtherEducationId);
    //         if (!furtherEducation) return;

    // }

    static getFurtherEducationCodeAndValidityData(userFurtherEducations: IRecordUserFurtherEducationSimple[], furtherEducationId: string): IRecordUserQualificationValidityData {
        const result: IRecordUserQualificationValidityData = {
            furtherEducationId,
            recordUserFurtherEducationId: "",
            furtherEducationValid: false,
            furtherEducationValidityEndDate: null
        };
        if (!furtherEducationId) return result;
        const relevantUserFurtherEducations = userFurtherEducations.filter(i => i.furtherEducationId === furtherEducationId && !i.getIsArchived());
        if (relevantUserFurtherEducations.length < 1) return result;
        relevantUserFurtherEducations.sort((a: IRecordUserFurtherEducationSimple, b: IRecordUserFurtherEducationSimple) => {
            if (!a || !b) return 0;
            return -1 * Base.numCompare(a.validityEndDate ?? Number.MAX_VALUE, b.validityEndDate ?? Number.MAX_VALUE);
        });
        const recordUserFurtherEducation = relevantUserFurtherEducations[0];
        const validityEndDate = recordUserFurtherEducation.validityEndDate;
        result.recordUserFurtherEducationId = recordUserFurtherEducation.id;
        result.furtherEducationValidityEndDate = validityEndDate;
        result.furtherEducationValid = !validityEndDate || validityEndDate >= Base.getNowDateTicks();
        return result;
    }

    static getFurtherEducationCodeAndValidityDatas(userFurtherEducations: IRecordUserFurtherEducationSimple[], furtherEducationIds: string[]): IRecordUserQualificationValidityData[] {
        const result: IRecordUserQualificationValidityData[] = [];
        if (!furtherEducationIds || !furtherEducationIds.length) return result;
        const relevantUserFurtherEducations = userFurtherEducations.filter(i => furtherEducationIds.indexOf(i.furtherEducationId) > -1 && !i.getIsArchived());
        if (relevantUserFurtherEducations.length < 1) return result;
        relevantUserFurtherEducations.sort((a: IRecordUserFurtherEducationSimple, b: IRecordUserFurtherEducationSimple) => {
            if (!a || !b) return 0;
            return -1 * Base.numCompare(a.validityEndDate ?? Number.MAX_VALUE, b.validityEndDate ?? Number.MAX_VALUE);
        });
        return relevantUserFurtherEducations.map(i => {
            return {
                furtherEducationId: i.furtherEducationId,
                recordUserFurtherEducationId: i.id,
                furtherEducationValidityEndDate: i.validityEndDate,
                furtherEducationValid: !i.validityEndDate || i.validityEndDate >= Base.getNowDateTicks()
            };
        });
    }

    static setCodeAndValidity(qualification: IRecordQualificationSimple, furtherEducationGroups: IRecordFurtherEducationGroupNode[], userFurtherEducations: IRecordUserFurtherEducationSimple[]) {
        qualification.code = "";
        qualification.furtherEducations = [];
        qualification.userFurtherEducations = [];
        qualification.validUserFurtherEducations = [];
        qualification.requiredQualificationCount = 0;
        if (qualification.furtherEducationId) {
            const furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(furtherEducationGroups, qualification.furtherEducationId);
            if (!furtherEducation) return;
            qualification.code = furtherEducation.code;
            const data = RecordListItemUserQualification.getFurtherEducationCodeAndValidityData(userFurtherEducations, qualification.furtherEducationId);
            if (!data.recordUserFurtherEducationId) return;
            qualification.userFurtherEducations.push(RecordQualificationUserFurtherEducation.Create(data.recordUserFurtherEducationId, qualification.code, data.furtherEducationValid, data.furtherEducationValidityEndDate));
        } else if (qualification.furtherEducationGroupId) {
            const furtherEducationGroup = RecordFurtherEducationGroupNode.getRecordFurtherEducationGroupNodeById(furtherEducationGroups, qualification.furtherEducationGroupId);
            if (!furtherEducationGroup) return;
            qualification.code = furtherEducationGroup.code;
            qualification.requiredQualificationCount = furtherEducationGroup.requiredQualificationCount;
            for (const child of furtherEducationGroup.children) {
                qualification.furtherEducations.push(RecordQualificationUserFurtherEducation.Create(child.id, child.code, false, 0));
            }
            const data = RecordListItemUserQualification.getFurtherEducationCodeAndValidityDatas(userFurtherEducations, furtherEducationGroup.children.map(i => i.id));
            for (const item of data) {
                const furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(furtherEducationGroups, item.furtherEducationId);
                qualification.userFurtherEducations.push(RecordQualificationUserFurtherEducation.Create(item.recordUserFurtherEducationId, furtherEducation.code, item.furtherEducationValid, item.furtherEducationValidityEndDate));
            }
        }
        RecordQualificationUserFurtherEducation.sortRecordQualificationUserFurtherEducation(qualification.userFurtherEducations, "validityEndDate", true);
        qualification.validUserFurtherEducations = qualification.userFurtherEducations.filter(i => i.valid);
        qualification.valid = qualification.requiredQualificationCount > 0
            ? qualification.validUserFurtherEducations.length >= qualification.requiredQualificationCount
            : qualification.validUserFurtherEducations.length > 0;
        let validityEndDates: number[];
        if (qualification.valid) {
            validityEndDates = qualification.validUserFurtherEducations.filter(i => i.validityEndDate).map(i => i.validityEndDate);
        } else {
            validityEndDates = qualification.userFurtherEducations.filter(i => i.validityEndDate).map(i => i.validityEndDate);
        }
        qualification.validityEndDate = validityEndDates.length
            ? Math.min(...validityEndDates)
            : null;
    }

    static setFurtherEducationCodesAndValidity(qualifications: IRecordListItemUserQualification[], furtherEducationGroups: IRecordFurtherEducationGroupNode[], userFurtherEducations: IRecordListItemUserFurtherEducation[]) {
        for (const qualification of qualifications) {
            RecordListItemUserQualification.setCodeAndValidity(qualification, furtherEducationGroups, userFurtherEducations);
            const userFurtherEducationIds = qualification.userFurtherEducations.map(i => i.id);
            const validUserFurtherEducationIds = qualification.validUserFurtherEducations.map(i => i.id);
            //Additional properties used in mobile UI
            qualification.fullUserFurtherEducations = [];
            qualification.fullQualificationUserFurtherEducations = [];
            if (qualification.userFurtherEducations.length > 0) {
                qualification.fullUserFurtherEducations = userFurtherEducations.filter(i => validUserFurtherEducationIds.indexOf(i.id) > -1)
                    .concat(userFurtherEducations.filter(i => validUserFurtherEducationIds.indexOf(i.id) < 0 && userFurtherEducationIds.indexOf(i.id) > -1));
            }
            //Further educations that are part of the qualification
            let foundFullUserFurtherEducations: IRecordListItemUserFurtherEducation[] = [];
            const notFoundFullUserFurtherEducations: IRecordListItemUserFurtherEducation[] = [];
            for (const furtherEducation of qualification.furtherEducations) {
                const validFullUserFurtherEducations = qualification.fullUserFurtherEducations.filter(i => i.furtherEducationId === furtherEducation.id && validUserFurtherEducationIds.indexOf(i.id) > -1);
                if (validFullUserFurtherEducations.length > 0) {
                    foundFullUserFurtherEducations = foundFullUserFurtherEducations.concat(validFullUserFurtherEducations);
                } else {
                    let fullUserFurtherEducation = qualification.fullUserFurtherEducations.find(i => i.furtherEducationId === furtherEducation.id);
                    if (fullUserFurtherEducation) {
                        foundFullUserFurtherEducations.push(fullUserFurtherEducation);
                    } else {
                        fullUserFurtherEducation = new RecordListItemUserFurtherEducation();
                        fullUserFurtherEducation.furtherEducationId = furtherEducation.id;
                        fullUserFurtherEducation.furtherEducationCode = furtherEducation.code;
                        fullUserFurtherEducation.modifyDate = 0;
                        notFoundFullUserFurtherEducations.push(fullUserFurtherEducation);
                    }
                }
            }
            RecordListItemUserFurtherEducation.sortRecordListItemUserFurtherEducations(foundFullUserFurtherEducations, "state", true);
            RecordListItemUserFurtherEducation.sortRecordListItemUserFurtherEducations(notFoundFullUserFurtherEducations, "code", true);
            qualification.fullQualificationUserFurtherEducations = foundFullUserFurtherEducations.concat(notFoundFullUserFurtherEducations);
            qualification.state = qualification.userFurtherEducations.length
                ? (qualification.valid
                    ? UserFurtherEducationState.Valid
                    : UserFurtherEducationState.Expired)
                : UserFurtherEducationState.Archived;
        }
    }

    static getValidQualificationNumberStr(qualification: IRecordQualificationSimple): string {
        return (qualification.furtherEducationGroupId
            ? " (" + qualification.validUserFurtherEducations.length.toString(10) + " / " + qualification.requiredQualificationCount.toString(10) + ")"
            : "");
    }

    static getQualificationState(qualification: IRecordQualificationSimple): string {
        return (qualification.userFurtherEducations.length
            ? (qualification.valid
                ? Translations.Valid
                : Translations.Expired)
            : Translations.Missing) + RecordListItemUserQualification.getValidQualificationNumberStr(qualification);
    }

    static getQualificationStateColor(qualification: IRecordQualificationSimple): string {
        return qualification.userFurtherEducations.length
            ? (qualification.valid
                ? stateGreen
                : stateOrange)
            : stateRed;
    }

    static sortRecordListItemUserQualifications(items: IRecordListItemUserQualification[], column: string, asc: boolean): IRecordListItemUserQualification[] {
        if (!items && items.length < 2) return items;
        if (column === "state") {
            return items.sort((a: IRecordListItemUserQualification, b: IRecordListItemUserQualification) => {
                if (!a || !b) return 0;
                const result = (asc ? 1 : -1) * Base.numCompare(a.state, b.state);
                if (result !== 0) return result;
                return (asc ? 1 : -1) * Base.strCompare(a.code, b.code);
            });
        } else {
            return items.sort((a: IRecordListItemUserQualification, b: IRecordListItemUserQualification) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    }
}